import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    illustrations: [{
      type: "Illustration digitale",
      title: "La Louve Blanche de Françoise Aubry",
      min: "img/p/louve-min.jpg",
      carousel: [{
        img: "./img/p/louve0.jpg",
        min: "./img/p/louve0.jpg",
      }, {
        img: "./img/p/louve1.jpg",
        min: "./img/p/louve1.jpg",
      }, {
        img: "./img/p/louve2.jpg",
        min: "./img/p/louve2.jpg",
      }]
    }, {
      type: "Illustration digitale",
      title: "Thème jeunesse",
      min: "img/p/jeunesse-min.jpg",
      carousel: [
        {
          img: "./img/renards.jpg",
          min: "./img/renards-min.jpg",
        },
        {
          img: "./img/Lapinspaques.jpg",
          min: "./img/Lapinspaques-min.jpg",
        },
        {
          img: "./img/renardsnuit.jpg",
          min: "./img/renardsnuit-min.jpg",
        },
      ]
    }, {
      type: "Projet personnel d'illustration",
      title: "Terremer d'Ursula K. Le Guin",
      min: "img/p/terremer-min.jpg",
      carousel: [{
        img: "./img/p/terremer1.jpg",
        min: "./img/p/terremer1.jpg",
      }]
    }, {
      type: "Projet personnel d'illustration",
      title: "Le Corbeau et le Renard",
      min: "img/p/corbeaurenard.jpg",
      carousel: [{
        img: "https://66.media.tumblr.com/c78ede17c5c79ba4aa1f8134959cd3cf/0db1ae71ceab1a5a-99/s1280x1920/1b7ac59eaaa7cbc9be57fcdc6cb2a17df46d42b1.jpg",
        min: "https://66.media.tumblr.com/c78ede17c5c79ba4aa1f8134959cd3cf/0db1ae71ceab1a5a-99/s1280x1920/1b7ac59eaaa7cbc9be57fcdc6cb2a17df46d42b1.jpg",
      }]
    }],

    strips: [{
      min: "./img/worms-min.jpg",
      img: "./img/worms.jpg",
    }, {
      min: "./img/18deg-min.jpg",
      img: "https://68.media.tumblr.com/a18a664facdd739682acef7d49b71acb/tumblr_p5e8hliUjJ1rep5ato1_r1_1280.jpg",
    }, {
      min: "./img/herbesprovence-min.jpg",
      img: "https://68.media.tumblr.com/4d7da984b0b5cd90780c37173f895ed1/tumblr_p5fsvuvnV41rep5ato1_1280.jpg",
    },
    {
      min: "./img/appelmasquevignette.jpg",
      img: "https://66.media.tumblr.com/deefb9637b69e2d078a240fe1a019b3d/71c45534f07c6d75-c0/s1280x1920/4d46b863ba95a7500f5e85b239a97a70a6208479.jpg",
    }, {
      min: "./img/latache-min.jpg",
      img: "https://66.media.tumblr.com/b0e61206910dab1da91035739b2a5486/5bd5bf9d29f4c9d7-64/s1280x1920/b2619616655e192be66fda616ec0588e6724b1b5.jpg",
    }, {
      min: "./img/livraisonadomicile-min.jpg",
      // @TODO: full image ? gallery ?
      img: "./img/p/bd6entiere.jpg",
    }],

    originals: [{
      min: "./img/NaoetMat-mini.jpg",
      img: "https://66.media.tumblr.com/13d0563e309a2cc63029b59bde039e39/49704d8479a76629-f8/s1280x1920/07e0ec026bd515af30b38ef2310b4d3059a91549.jpg",
      description: "Couple mignon - Peinture numérique",
      category: "order",
    }, {
      min: "./img/jardin japonais_min.jpg",
      img: "https://78.media.tumblr.com/1e6078acd82db546c79f7d93f0bd564e/tumblr_p955gu03AM1rep5ato1_1280.jpg",
      description: "Jeune fille à l'étang",
      category: "watercolor",
    }, {
      min: "./img/jardin_min.jpg",
      img: "https://78.media.tumblr.com/68719b6b2cd2ebeda7e67c10e61dde66/tumblr_p8rw4pljQX1rep5ato1_1280.jpg",
      description: "Après-midi d'été",
      category: "watercolor",
    }, {
      min: "./img/moto.jpg",
      img: "https://68.media.tumblr.com/1aa1dc4af9322a707bb9dfebf4226047/tumblr_p7nnzeY4d41rep5ato1_1280.jpg",
      description: "Faire-part de mariage - Peinture numérique",
      category: "order",
    }, {
      min: "./img/dungeon.jpg",
      img: "https://68.media.tumblr.com/c19b3cd03678b1094fd764f9b9a4a62a/tumblr_p6noxodFdT1rep5ato1_1280.jpg",
      description: "Mystères du donjon",
      category: "digital",
    }, {
      min: "./img/filleavelo-mini.jpg",
      img: "https://66.media.tumblr.com/f8c9ddbcc3df67badcb539a1febbf79c/tumblr_pdio0p5KCp1rep5ato1_1280.jpg",
      description: "Promenade le long des champs",
      category: "digital",
    }, {
      min: "./img/mermaidpiege-mini.jpg",
      img: "https://66.media.tumblr.com/bc69d18d20883c1e635d6995c4d3ece6/893a14cd6c218471-fb/s1280x1920/12abb9bfddeed80e0df35a0a7e5e583e1059fb7a.jpg",
      description: "Sirène espiègle",
      category: "digital",
    }, {
      min: "./img/maliki.jpg",
      img: "https://68.media.tumblr.com/c299573f053025f1dab8d066cd0b8033/tumblr_p6ba93SpiQ1rep5ato1_1280.jpg",
      description: "Concours Maliki Blog 2 - L'union fait la force",
      category: "order",
    }, /*{
      min: "./img/sirenemin.jpg",
      img: "https://68.media.tumblr.com/4c498651b83403223c7c44094cc66bd8/tumblr_o7zpqshLCr1rep5ato1_1280.jpg",
      description: "Réalisation personnelle - Peinture numérique",
      category: "digital",
    },*/ /*{
      min: "./img/animalmin.jpg",
      img: "https://68.media.tumblr.com/e0e3284609a5f1d432c12ce3a8153423/tumblr_nyp7slj6wK1rep5ato1_1280.jpg",
      description: "Réalisation personnelle - Peinture numérique",
      category: "digital",
    },*/ {
      min: "./img/eliesaabmin.jpg",
      img: "https://78.media.tumblr.com/3350a462e4373b125215d9f97f0d24bd/tumblr_nrxv9j9xt71rep5ato3_1280.jpg",
      description: "Robe inspirée - Peinture numérique sur photo",
      category: "digital",
    }, {
      min: "./img/allegorienaturemin.jpg",
      img: "http://www.image-heberg.fr/files/15188927141738296915.jpg",
      description: "Mère nature",
      category: "digital",
    }, /*{
      min: "./img/femmemin.jpg",
      img: "https://78.media.tumblr.com/23abf2d73f21dcc98525442184dc0599/tumblr_np9wsveDID1rep5ato1_1280.jpg",
      description: "Réalisation personnelle - Peinture numérique",
      category: "digital",
    },*/ {
      min: "./img/aidamin.jpg",
      img: "http://78.media.tumblr.com/90b5c6b611b951a42ae27a3f498329c9/tumblr_n724o6gKKP1rep5ato1_1280.jpg",
      description: "Aïda",
      category: "digital",
    }, {
      min: "http://78.media.tumblr.com/2326c61f9c20623500bec5caf6d3757c/tumblr_oe45osiwNL1rep5ato1_1280.gif",
      img: "http://78.media.tumblr.com/2326c61f9c20623500bec5caf6d3757c/tumblr_oe45osiwNL1rep5ato1_1280.gif",
      description: "Une vie de chat",
      category: "watercolor",
    }, {
      min: "./img/Chat2min.jpg",
      img: "https://68.media.tumblr.com/14009ec20dea72c7d87815f8c5058069/tumblr_oqj30xfMGB1rep5ato1_1280.jpg",
      description: "Peinture numérique pour l'association Doubs Espoirs",
      category: "order",
    }, {
      min: "./img/Clubrockmin.jpg",
      img: "http://78.media.tumblr.com/abe9946ec07e2f77c577ec47cfc99f50/tumblr_oftsb7Fvdv1rep5ato1_1280.jpg",
      description: "Club Rock",
      category: "digital",
    }, {
      min: "./img/100fansmin.jpg",
      img: "http://78.media.tumblr.com/634277a8d61688c748df7c960bdaed73/tumblr_nrxvgxZEDQ1rep5ato1_1280.jpg",
      description: "Auto-portrait",
      category: "digital",
    }, /*{
      min: "./img/me2cspmin.jpg",
      img: "https://78.media.tumblr.com/fe5d9c18cdb619da671eaaa98520b1a7/tumblr_oxgrncjdcF1rep5ato1_r1_1280.jpg",
      description: "Repos",
      category: "digital",
    },*/  {
      min: "./img/bonhommesdeneige-min.jpg",
      img: "http://78.media.tumblr.com/eb763d201abf673a6756c042fd6eb534/tumblr_ozsjlmmE2g1rep5ato1_1280.jpg",
      description: "Noël au frais - Aquarelle",
      category: "cards",
    }, {
      min: "./img/Renneperenoel-min.jpg",
      img: "http://78.media.tumblr.com/6a517228ac6060d70f30cbcfd232b985/tumblr_ozsjlmmE2g1rep5ato2_1280.jpg",
      description: "Sur le départ - Aquarelle",
      category: "cards",
    }, {
      min: "./img/Chatnoel-min.jpg",
      img: "http://78.media.tumblr.com/c9844e0c378f73bfafeadab252fbcc4b/tumblr_ozsjlmmE2g1rep5ato4_1280.jpg",
      description: "Lendemain de Noël - Aquarelle",
      category: "cards",
    }, {
      min: "./img/Maisonsousneige-min.jpg",
      img: "http://78.media.tumblr.com/c306f276251e21def9610795d0d71ade/tumblr_ozsjlmmE2g1rep5ato5_1280.jpg",
      description: "Petit chalet - Aquarelle",
      category: "cards",
    }, {
      min: "./img/villenuitnoel-mini.jpg",
      img: "https://66.media.tumblr.com/66b60a26e40e5a22c415a300c97f898c/2eaee96477589112-bc/s1280x1920/2a643b4db706067ac2cc44d7eef7e6578cef8c68.jpg",
      description: "Noël en Alsace - Aquarelle",
      category: "cards",
    }, {
      min: "./img/perenoel-mini.jpg",
      img: "https://66.media.tumblr.com/2ceeca0c88fe02263a589ed4a0978621/2eaee96477589112-31/s1280x1920/bb770f4a76bba10a08f2192ba620ebe452cbff3b.jpg",
      description: "Le repos - Aquarelle",
      category: "cards",
    }, {
      // @TODO
      min: "./img/Carte5-min.jpg",
      img: "https://66.media.tumblr.com/75b494b84fdf8f4c51668385b76ad732/tumblr_ozsjlmmE2g1rep5ato3_1280.jpg",
      description: "Anticipation - Aquarelle",
      category: "cards",
    }, {
      min: "./img/simplesetpotions-min.jpg",
      img: "https://66.media.tumblr.com/fafd725543ce98377435201b2998b20a/tumblr_pjpzhjjqnd1rep5ato1_1280.jpg",
      description: "Simples et potions",
      category: "watercolor",
    }, {
      min: "./img/rencontrebar-mini.jpg",
      img: "https://66.media.tumblr.com/05fc769f4b899c336d714d3cd339e02f/tumblr_phbt8ei2f31rep5ato1_1280.jpg",
      description: "Rencontre dans une taverne",
      category: "watercolor",
    }, {
      min: "./img/souris-mini.jpg",
      img: "https://66.media.tumblr.com/a152848af3b88a67f9243ae52032d66a/tumblr_ph0k9nfytk1rep5ato1_1280.jpg",
      description: "Souris magicienne",
      category: "watercolor",
    }, {
      min: "./img/lapineaventuriere-mini.jpg",
      img: "https://66.media.tumblr.com/3fbfd22d760d31fb0297890b6750b702/tumblr_ph2ieinqMH1rep5ato1_1280.jpg",
      description: "Lapine aventurière",
      category: "watercolor",
    }, {
      min: "./img/sireneaquarelle-mini.jpg",
      img: "https://66.media.tumblr.com/1f68ba819880ce466e04b01019db5e0a/952e1bc1579d9b33-c8/s1280x1920/6a3c510de3d9ec93048b95d20db65da4f32a3462.jpg",
      description: "Trésor personnel",
      category: "watercolor",
    }, {
      min: "./img/Meathomemini.jpg",
      img: "https://68.media.tumblr.com/18203da96d1893282432ecfbefa41eb7/tumblr_oy9x4gPwAt1rep5ato1_1280.jpg",
      description: "Home sweet home",
      category: "watercolor",
    }, {
      min: "./img/PlantesEtPotionsMin.jpg",
      img: "http://78.media.tumblr.com/69e10e06b71556908849f467cc877c96/tumblr_p3zjc7B5Vd1rep5ato1_1280.jpg",
      description: "Nature morte",
      category: "watercolor",
    }, {
      min: "./img/dragon-min.jpg",
      img: "https://imgix.ttcdn.co/i/product/original/0/452455-9ce03b62c0934c7daeca3aad552f3f0a.jpeg?quality=50&width=2000&bg-color=fff&auto=webp&fit=bounds&fm=jpeg",
      description: "Dragon chinois - Encre",
      category: "watercolor",
    }, ]
  },

  mutations: {},
  actions: {},
  modules: {},
})
